import { Component, Input, OnInit } from '@angular/core'
import { ResearchSession } from '../../../types'
import { CommonModule } from '@angular/common'
import { ResearchService } from '../../../services/research.service'
import { StatisticsService } from '../../../services/statistics.service'
import { TranslocoDirective } from '@jsverse/transloco'

@Component({
   selector: 'app-research-session',
   standalone: true,
   imports: [TranslocoDirective, CommonModule],
   templateUrl: './research-session.component.html',
   styles: ''
})
export class ResearchSessionComponent implements OnInit {

   @Input() session!: ResearchSession & { niceDate?: string}

   get currentResearchSession() {
      return this.research.researchSession
   }

   constructor(private research: ResearchService, private stats: StatisticsService) { }

   ngOnInit() {
      this.session.niceDate = new Date(this.session.creationDate).toLocaleString()
   }

   removeHistoryEntry(session: ResearchSession) {
      this.stats.sendEvent({ category: 'session', action: 'remove', label: 'sessionid', value: session.id })
      this.research.removeHistoryEntry(session)
   }

   loadHistoryEntry(session: ResearchSession) {
      this.stats.sendEvent({ category: 'session', action: 'load', label: 'sessionid', value: session.id })
      this.research.loadHistoryEntry(session)
   }

   changeName(session: ResearchSession) {
      this.stats.sendEvent({ category: 'session', action: 'rename', label: 'sessionid', value: session.id })
      this.research.generateTopicName(session)
   }
}
